import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';

import styles from './styles.module.scss';

const MorphingPromoBlock = ({ title, description, image, url }) => (
	<a
		href={url}
		className={cx(styles.block, 'swiper-lazy')}
		data-background={image}
	>
		<div className={styles.inner}>
			<div className={styles.content}>
				<div className={styles.title}>{title}</div>
				<div className={styles.description}>{description}</div>
				<div className={styles.more}>
					Подробнее
					<Icon icon="more" className={styles.icon} />
				</div>
			</div>
		</div>
	</a>
);

MorphingPromoBlock.propTypes = {
	title: PropTypes.string.isRequired,
	image: PropTypes.string.isRequired,
	description: PropTypes.string,
	url: PropTypes.string
};

export default MorphingPromoBlock;
